import { render, staticRenderFns } from "./VuesticDataTable2.vue?vue&type=template&id=46f44b76"
import script from "./VuesticDataTable2.vue?vue&type=script&lang=js"
export * from "./VuesticDataTable2.vue?vue&type=script&lang=js"
import style0 from "./VuesticDataTable2.vue?vue&type=style&index=0&id=46f44b76&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f44b76')) {
      api.createRecord('46f44b76', component.options)
    } else {
      api.reload('46f44b76', component.options)
    }
    module.hot.accept("./VuesticDataTable2.vue?vue&type=template&id=46f44b76", function () {
      api.rerender('46f44b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-datatable/VuesticDataTable2.vue"
export default component.exports